<template>
  <div class="mainContainer">
    <!-- <Navbar></Navbar> -->
    <DetailPage
      v-for="item in content"
      :content="item"
      @change="change"
      :type="type"
      :data="form"
    />
    <div class="flex-between footer">
      <div>小计：{{ purchaseAmount }}</div>
      <van-button type="info" @click="modifyConfirm">确定</van-button>
    </div>
  </div>
</template>
<script>
import DetailPage from "@/components/detailPage";
import { get } from "../../../service/api/product";
// import Navbar from "../../components/navbar.vue";

export default {
  name: "index",
  components: { DetailPage },
  data() {
    return {
      form: {
        categoryName: "",
        externalCode: "",
        productPurchasePrice: "",
        retailPrice: "",
        stockNum: "",
        purchaseNum: "",
        purchasePrice: "",
        productionDate: "",
        shelfLifeDays: "",
        isGift: false,
      },
      purchaseAmount: 0,
      type: "",
      content: [
        {
          title: "商品信息",
          rows: [
            {
              label: "商品名称",
              key: "productName",
              editable: false,
            },
            {
              label: "商品条码",
              key: "externalCode",
              editable: false,
            },
            {
              label: "采购价",
              key: "productPurchasePrice",
              editable: false,
            },
            {
              label: "零售价",
              key: "retailPrice",
              editable: false,
            },
          ],
        },
        {
          title: "库存信息",
          rows: [
            {
              label: "当前库存",
              key: "stockNum",
              editable: false,
            },
          ],
        },
        {
          title: "采购信息",
          rows: [
            {
              label: "是否赠品",
              key: "isGift",
              editable: true,
              type: "switch",
            },
            {
              label: "采购数量",
              key: "purchaseNum",
              editable: true,
              type:'number'
            },
            {
              label: "采购单价",
              key: "purchasePrice",
              editable: true,
              type:'number'
            },
            
            {
              label: "生产日期",
              key: "productionDate",
              editable: true,
              type: "dialog",
              component: "DateTimePicker",
              visible: "showDatePicker",
              show: "",
            },
            {
              label: "保质期",
              key: "shelfLifeDays",
              editable: true,
              type: "number",
            },
          ],
        },
      ],
      orderingKey: "",
      ordering: {},
    };
  },
  watch: {
    form(newVal) {
      const key = "purchaseNum";
      // 如果是赠品，小计为0，否则按正常计算
      if (newVal.isGift) {
        this.purchaseAmount = 0;
      } else {
        this.purchaseAmount = this.$utils.mul(newVal[key], newVal.purchasePrice);
      }
    },
    'form.isGift'(newVal) {
      if (newVal) {
        // 如果是赠品，设置采购价为0
        this.form.purchasePrice = 0;
        // 更新content配置，禁用采购单价编辑
        this.updatePurchasePriceEditable(false);
      } else {
        // 如果不是赠品，恢复采购价的编辑权限
        this.updatePurchasePriceEditable(true);
      }
    },
  },
  mounted() {
    this.type = this.$route.query && this.$route.query.type;
    debugger;
    this.getInfo();
    // 初始化时根据isGift状态设置采购价编辑权限
    this.updatePurchasePriceEditable(!this.form.isGift);
  },
  methods: {
    change(newVal) {
      this.form = Object.assign({}, this.form, newVal);
    },
    updatePurchasePriceEditable(editable) {
      // 更新采购单价的可编辑状态
      const purchaseInfoSection = this.content.find(section => section.title === "采购信息");
      if (purchaseInfoSection) {
        const purchasePriceRow = purchaseInfoSection.rows.find(row => row.key === "purchasePrice");
        if (purchasePriceRow) {
          purchasePriceRow.editable = editable;
        }
      }
    },
    async getInfo() {
      
      const id = this.$route.params.id;
      let data = [];
      this.orderingKey = "purchaseOrdering";
      this.ordering = JSON.parse(
        localStorage.getItem(this.orderingKey) || "{}"
      );
      
      if (this.ordering.tableData && this.ordering.tableData.length > 0) {
        data = this.ordering.tableData;
      }

      if (data && data.length > 0) {
        this.form = data.filter((el) => el.productId == id)[0];
        // 确保isGift字段存在，如果不存在则默认为false
        if (this.form.isGift === undefined) {
          this.form.isGift = false;
        }
        // 根据isGift状态更新采购价编辑权限
        this.updatePurchasePriceEditable(!this.form.isGift);
        
        return;
      }
      const res = await get(id);
      this.form = { ...res.data, available: res.data.available ? "1" : "0", isGift: false };
      // 初始化时根据isGift状态设置采购价编辑权限
      this.updatePurchasePriceEditable(!this.form.isGift);
    },
    toAnalysis(id) {
      this.$router.push("/analysis/product", { id });
    },
    modifyConfirm() {
      if (this.type === "edit") {
        // 确保赠品数据正确处理
        if (this.form.isGift) {
          this.form.purchasePrice = 0;
        }
        this.ordering.tableData = this.ordering.tableData.map((el) => {
          if (el.productId === this.form.productId) {
            el = Object.assign(el, this.form);
          }
          return el;
        });
        
        localStorage.setItem("purchaseOrdering", JSON.stringify(this.ordering));
      }
      this.$router.back();
    },
  },
};
</script>
<style lang="less" scoped>
.footer {
  padding: 5px 10px;
  background-color: #fff;
  align-items: center;
  font-size: 16px;
}
</style>
